<script>
    import CartCouponForm from './CartCouponForm'
    import {Form} from '../../helpers/Form/Form'

    export default {
        props: ['mainForm', 'stripe', 'routeTabs', 'intentPayment', 'inPayment', 'showButton'],
        components: {CartCouponForm},
        data() {
            return {
                gtagEvents: [],
                form: this.mainForm,
                isLoading: false,
            }
        },
        computed: {
            hasAlreadySaveACard() {
                return !_.isEmpty(this.mainForm.card_brand) && !_.isEmpty(this.mainForm.card_last_four) && !_.isEmpty(this.mainForm.stripe_id)
            }
        },
        mounted() {
            this.$bus.$on('submit-confirm', () => {
                this.onSubmit()
            })

            this.$bus.$on('update-course-promotion-analytics', () => {
                this.gtagEvents.push('course-promotion')
            })
        },
        methods: {
            onEditBillingData() {
                if (! this.form.has_already_bought) {
                    this.onSwitchTab('billing')
                } else {
                    this.switchSubTab('billing')
                }
            },
            async onSubmit() {
                $("#spinner-modal").modal()

                this.isLoading = true;

                await this.beforePay()
                // console.log(this);

                // gtag
                if (this.gtagEvents.includes('course-promotion')) {
                    gtag('event', 'Form', {
                        'event_category': 'OrangoPack',
                        'event_label': '#acquisto_OrangoPack'
                    });

                    this.gtagEvents.splice(
                        this.gtagEvents.indexOf('course-promotion'), 1
                    );
                }
            },

            async beforePay() {
                const self = this;
                await this.form
                    .submit('post', route('carts.total_before_pay'))
                    .then(async response => {
                        this.$set(this.form, 'total', response.totalPrice)

                        if (this.form.total > 0) {
                            if (this.form.payment == 'card') {
                                await this.completeWithPayment()
                            } else if (this.form.payment == 'sepa_debit') {
                                await this.completeWithSepaDebitPayment()
                            } else if (this.form.payment == 'soisy') {
                                this.onPostBuy()
                            }
                        } else {
                            await this.completeWithoutPayment()
                        }
                    })
                    .catch(error => {
                        self.submitRunning = false;
                        self.isLoading = false;
                        $("#spinner-modal").modal('hide');
                        if(error.errors)
                            window.alerts.error(error.errors.message);
                        else
                            window.alerts.error('Qualcosa è andato storto durante la verifica del pagamento!');

                    });
            },
            completeWithSepaDebitPayment() {
                const self = this;
                self.form.i_payment = self.inPayment;
                self.form.pay_method = self.form.stripeToken;
                // console.log(self.form, this.form);
                // return false;
                this.form
                    .submit('post', route('payintent.sepa_debit'), {}, true)
                    .then( async ({intent}) => {
                        let {paymentIntent, error} = await this.stripe
                            .form
                            .confirmSepaDebitPayment(intent.client_secret, {
                                payment_method: self.form.stripeToken,
                            });

                        if (!error) {
                            this.$set(this.form, 'stripeToken', self.form.stripeToken)
                            this.$set(this.form, 'i_payment', intent.id)
                            this.onPostBuy()
                        } else {
                            try  {
                                await this.form.submit('delete', route('payintent.sepa_debit_delete', intent.id))
                            } catch (e) {

                            }

                            window.alerts.error(error.message)
                            self.isLoading = false;
                            this.$emit('update-tab', 'payment');
                        }
                    })
                    .catch(error => {
                        self.submitRunning = false;
                        self.isLoading = false;
                        $("#spinner-modal").modal('hide');
                        if(error.errors)
                            window.alerts.error(error.errors.message);
                        else
                            window.alerts.error('Qualcosa è andato storto durante la verifica del pagamento!');
                        self.$emit('update-tab', 'payment');
                    })
            },
            completeWithoutPayment() {
                this.form
                    .submit('post', route('carts.without_payment'))
                    .then(({redirect}) => {
                        $("#spinner-modal").modal('hide');
                        this.isLoading = false;

                        location.href = redirect
                    })
            },
            completeWithPayment() {
                const self = this;
                self.form.i_payment = self.inPayment;
                self.form.pay_method = self.form.stripeToken;
                // console.log(self.form, this.form);
                // return false;
                this.form
                    .submit('post', route('payintent.create'), {}, true)
                    .then( async ({intent}) => {
                        // return false;
                        // console.log(intent)
                        if (intent.status == 'succeeded') {
                            // $("#spinner-modal").modal()
                            this.$set(this.form, 'stripeToken', self.form.stripeToken)
                            this.$set(this.form, 'i_payment', intent.id)
                            this.onPostBuy()
                        } else {
                            self.form.p_intent = intent.id
                            $("#spinner-modal").modal('hide');
                            const {paymentIntent, error} = await this.stripe.form.handleCardAction(
                                intent.client_secret
                            );

                            // console.log(paymentIntent, error)
                            if (error) {
                                // The payment failed -- ask your customer for a new payment method.
                                window.alerts.error(error.message)
                                self.isLoading = false;
                                this.$emit('update-tab', 'payment');
                            } else {
                                // The payment has succeeded.
                                $("#spinner-modal").modal()
                                this.$set(this.form, 'stripeToken', self.form.stripeToken)
                                this.$set(this.form, 'i_payment', intent.id)
                                this.onPostBuy()
                            }
                        }
                    })
                    .catch(error => {
                        self.submitRunning = false;
                        self.isLoading = false;
                        $("#spinner-modal").modal('hide');
                        if(error.errors)
                            window.alerts.error(error.errors.message);
                        else
                            window.alerts.error('Qualcosa è andato storto durante la verifica del pagamento!');
                        self.$emit('update-tab', 'payment');
                    })
            },
            onPostBuy() {
                this.form
                    .submit('post', 'postBuy')
                    .then(response => {
                        $("#spinner-modal").modal('hide');
                        this.isLoading = false;
                        // if(response.error)
                        //     window.alert.error(error.declineCode)
                        // console.log('res', response)
                        // return false;
                        location.href = response.redirect
                    })
                    .catch(error => {
                        // console.log('error', error);
                        $("#spinner-modal").modal('hide');
                        location.href = error.redirect 
                    })
            },
            onSwitchTab(tab) {
                this.$emit('update-tab', tab)
            },
            switchSubTab(subTab) {
                this.$emit('update-sub-tab', subTab)
            },
            updateTotal({total, exploitable_code, exploitable_used, discount}) {
                this.$set(this.form, 'total', total)
                this.$set(this.form, 'exploitable_code', exploitable_code)
                this.$set(this, 'exploitable_used', exploitable_used)
                this.$set(this, 'discount', discount)
                this.$bus.$emit('update-total', {
                    total,
                    exploitable_code,
                    exploitable_used,
                    discount
                })
            },
            onBack() {
                let idx = _.findIndex(this.routeTabs, r => r == 'confirm')
                this.$emit('update-tab', this.routeTabs[idx-1])
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/cart/ConfirmForm.vue